import template from './_stop.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  props: {
    stop: {
      type: Object,
      required: true
    },

    lastStop: {
      type: Boolean,
      required: true
    },

    selectedStopId: {
      type: String,
      default: undefined
    }
  },

  methods: {
    selectStop(stop) {
      this.$emit('select-stop', stop)
    }
  }
})
